// extracted by mini-css-extract-plugin
export default {"main":"Works_main__NQN7i","title":"Works_title__g+Ha+","text":"Works_text__XI4zr","flareAnimation":"Works_flareAnimation__2sTz8"};